/**
 * @title pharmacyresultsselfservice.js: Feature level module
 * @description The module used for displaying filters, drug networks and store location in bing map
 * feature which encapsulates the CMPP Landing Results Page.
 */
define(['pharmacyresultsselfservice1', 'linkMembership'], function(linkMembership) {
	if (typeof window.COSTCO == 'undefined') {
		window.COSTCO = new Object();
	}
	var PharmacyResultSelfService = {
		/**
	     * The desktop Div ID
	     */
	    desktopDivId: '#bing-map',
	    /**
	     * Mobile Div ID
	     */
	    mobileDivId: '#bing-map-mobile',
	    /**
	     * Bing Map Zoom Configuration Value
	     */
	    zoom: 11,
	    /**
	     * Bing Map weight Configuration Value
	     */
	    weight: 300,
	    /**
	     * Stores Address Push
	     */
	    setStoreAddressArr : [],
		/**
	     * Enter Keyword Code
	     */
		EnterKeywordCode : 13,
		/**
	     * Min Store Locations Visible
	     */
		minStoreLocationViewLength : 10,
	    /**
	     * Drug Search Min. Length Configuration
	     */
		drugSearchMinLength : 1,
		/**
	     * Drug Search Max. Length Configuration
	     */
		drugSearchMaxLength : 2,
		/**
	     * brandSelection declaration
	     */
		brandSelection : 0,
		/**
	     * formSelection declaration
	     */
		formSelection : 0,
		/**
	     * strengthSelection declaration
	     */
		strengthSelection : 0,
		/**
	     * packageSelection declaration
	     */
		packageSelection : 0,
		/**
	     * quantitySelection declaration
	     */
		quantitySelection : 0,
		/**
	     * dataSet declaration
	     */
		dataSet : "",
		/**
	     * drugBrandParam declaration
	     */
		drugBrandParam : "",
		
		/**
	     * drugGenericBrandParam declaration
	     */
		drugGenericBrandParam : "",
		/**
	     * drugFormParam declaration
	     */
		drugFormParam : "",
		/**
	     * drugAdditionalInformationPre declaration
	     */
		drugAdditionalInformationPre: "",
		/**
	     * drugAdditionalInformationDrugName declaration
	     */
		drugAdditionalInformationDrugName: "",
		/**
	     * drugAdditionalInformationDrugNameModal declaration
	     */		
		drugAdditionalInformationDrugNameModal: "",
		/**
	     * drugAdditionalInformationPost declaration
	     */
		drugAdditionalInformationPost: "",		
		/**
	     * currentH1BrandName declaration
	     */		
		currentH1BrandName: "",		
		/**
	     * drugStrengthParam declaration
	     */
		drugStrengthParam : "",
		/**
	     * drugPackageParam declaration
	     */
		drugPackageParam : "",
		/**
	     * drugQuantityParam declaration
	     */
		drugQuantityParam : "",
		/**
	     * drugPackageOrFormParam declaration
	     */
		drugPackageOrFormParam : "",
		/**
	     * changeBrandParam declaration
	     */
		changeBrandParam : false,
		/**
	     * changeFormParam declaration
	     */
		changeFormParam : false,
		/**
	     * changeStrengthParam declaration
	     */
		changeStrengthParam : false,
		/**
	     * changePackageParam declaration
	     */
		changePackageParam : false,
		/**
	     * changeQuantityParam declaration
	     */
		changeQuantityParam : false,
		/**
	     * showPackageIndicatorParam declaration
	     */
		showPackageIndicatorParam : false,
		/**
	     * isFreshSearch declaration
	     */
		isFreshSearch : false,			
		/**
	     * drugIdentifier declaration
	     */
		drugIdentifier : "",
		/**
	     * drugName declaration
	     */
		drugName : "",
		/**
	     * zipCode declaration
	     */
		zipCode : "",
		/**
	     * firstMarketingContentIndex declaration
	     */
		firstMarketingContentIndex : 0,
		/**
	     * secondMarketingContentIndex declaration
	     */
		secondMarketingContentIndex : 5,
		/**
	     * secondMarketingContentIndex declaration
	     */
		drugNDCIDParam : "",
		/* Adding Social SHARE Link popover, similar to the one in PDP*/
		pop_overs: function() {
            $('.co-info').popover({
              container: '.math-table'
            });
            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
                COSTCO.util.socialNetworksPopover('social-share-link'); 
            }
          },
		getDrugDetailsByIdentifierAuthDetails : function(){
			let CMPP_DRUG_SEARCH_END_POINT = 'CMPP_DRUG_DETAILS_BY_DRUG_IDENTIFIER_END_POINT';
			let apiURL = '';
			let token = '';
			let displayError = '';
			let responseTimeout = 0;
			$.get('/AjaxCostcoCMPPDrugAuthDetailsLookupView?action=token&apiName='+CMPP_DRUG_SEARCH_END_POINT)
			.done(function(data) {
				$('#cmppDrugNameTextID').val("");
				let object = JSON.parse(data);
				apiURL = object.apiURL;
				token = object.token;
				responseTimeout = object.responseTimeout;
				let drugIdentifier	= PharmacyResultSelfService.getUrlParameter('drugIdentifierParam');
				let useSelectedNDCAsDefaultParameter	= PharmacyResultSelfService.getUrlParameter('useSelectedNDCAsDefault');
				if(useSelectedNDCAsDefaultParameter!=undefined && useSelectedNDCAsDefaultParameter.toLowerCase()=='true'){
					useSelectedNDCAsDefaultParameter='?useSelectedNDCAsDefault=true';
				}else{
					useSelectedNDCAsDefaultParameter='';
				}
				$('#div_DrugNetworkResultsDisplay').addClass('ajax-busy');
				$('#div_DrugNetworkResultsDisplay .cmpp-loader').show();
				jQuery.ajax({
				    url: apiURL+drugIdentifier+ useSelectedNDCAsDefaultParameter,
				    type: 'GET',
				    timeout : responseTimeout,
				    headers: {
				    	"Content-Type": "application/json",
				    	"Accept": "application/json",
				    	'api-version': object.apiVersionNumber
				    },
				    beforeSend : function(xhr) {
				        xhr.setRequestHeader( 'Authorization', 'Bearer ' +token);
				    },
				    success: function(response) {
						PharmacyResultSelfService.getDrugDetailsByDrugIdentifier(response);
						$('#div_DrugNetworkResultsDisplay').removeClass('ajax-busy');
						$('#div_DrugNetworkResultsDisplay .cmpp-loader').hide();
				    },
				    error: function(xhr, ajaxOptions, thrownError) {
						console.log("Ajax Error>>"+thrownError);
						$('#div_DrugNetworkResultsDisplay').removeClass('ajax-busy');
						$('#div_DrugNetworkResultsDisplay .cmpp-loader').hide();
				    }
				});
			});
		},
	    /**
	     * 
	     */
		getDrugDetailsByDrugIdentifier : function(data){
			// populateBrands
			PharmacyResultSelfService.dataSet = data;
			PharmacyResultSelfService.populateBrands();
			$("#filter_brand").on("change",PharmacyResultSelfService.changeBrand);
			$("#filter_form").on("change",PharmacyResultSelfService.changeForm);
			$("#filter_strength").on("change",PharmacyResultSelfService.changeStrength);
			$("#filter_package").on("change",PharmacyResultSelfService.changePackage);
			$("#filter_quantity").on("change",PharmacyResultSelfService.changeQuantity);
			$("#cmpp_tabs").show();
			PharmacyResultSelfService.getDrugPriceDetailsByNDCNAuthDetails();
			$('#filter_brand option').each(function() {
				var text = $(this).text();
				if (text.length > 12 && $(window).width() < 952 && $(window).width() > 769) {
				  text = text.substring(0, 9) + '...';
				  $(this).text(text);
				}
				if (text.length > 28 && $(window).width() < 856 && $(window).width() > 769) {
					text = text.substring(0, 9) + '...';
					$(this).text(text);
				  }
				if (text.length > 28 && $(window).width() < 1210 && $(window).width() > 1088) {
					text = text.substring(0, 27) + '...';
					$(this).text(text);
				  }
				if (text.length > 28 && $(window).width() < 1087 && $(window).width() > 1026) {
					text = text.substring(0, 22) + '...';
					$(this).text(text);
				  }
				if (text.length > 28 && $(window).width() < 1025 && $(window).width() > 857) {
					text = text.substring(0, 18) + '...';
					$(this).text(text);
				  }
		  });
		},
		
		getUrlParameter: function(sParam) {
            let sPageURL = decodeURIComponent(window.location.search.substring(1));
            let sURLVariables = sPageURL.split('&');
            for (let i = 0; i < sURLVariables.length; i++) {
                let sParameterName = sURLVariables[i].split('=');
                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : sParameterName[1];
                }
            }
        },
		
		changeQuantity : function(item){
			PharmacyResultSelfService.changeQuantityParam = true;
			PharmacyResultSelfService.changeBrandParam = false;
			PharmacyResultSelfService.changeStrengthParam = false;
			PharmacyResultSelfService.changeFormParam = false;
			PharmacyResultSelfService.changePackageParam = false;
			
			PharmacyResultSelfService.drugQuantityParam = $(this).children("option:selected").val();
			PharmacyResultSelfService.populateDrugPackageFormDescription();
			PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header','tmpl_drug_selection_details_in_header');
			PharmacyResultSelfService.getDrugPriceDetailsByNDCNAuthDetails(item);
		},
		
		changeBrand : function(item){
			PharmacyResultSelfService.changeBrandParam = true;
			PharmacyResultSelfService.changeStrengthParam = false;
			PharmacyResultSelfService.changeFormParam = false;
			PharmacyResultSelfService.changePackageParam = false;
			PharmacyResultSelfService.changeQuantityParam = false;
			
			let index = $(this).children("option:selected").attr("data-index");
			PharmacyResultSelfService.brandSelection = index;
			PharmacyResultSelfService.drugBrandParam = $(this).children("option:selected").val();
			PharmacyResultSelfService.populateBrands();
			PharmacyResultSelfService.populateDrugPackageFormDescription();
			PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header','tmpl_drug_selection_details_in_header');
			PharmacyResultSelfService.getDrugPriceDetailsByNDCNAuthDetails(item);
			$('#filter_brand option').each(function() {
				var text = $(this).text();
				if (text.length > 12 && $(window).width() < 952 && $(window).width() > 769) {
				  text = text.substring(0, 9) + '...';
				  $(this).text(text);
				}
				if (text.length > 28 && $(window).width() < 856 && $(window).width() > 769) {
					text = text.substring(0, 9) + '...';
					$(this).text(text);
				  }
				if (text.length > 28 && $(window).width() < 1210 && $(window).width() > 1088) {
					text = text.substring(0, 27) + '...';
					$(this).text(text);
				  }
				if (text.length > 28 && $(window).width() < 1087 && $(window).width() > 1026) {
					text = text.substring(0, 22) + '...';
					$(this).text(text);
				  }
				if (text.length > 28 && $(window).width() < 1025 && $(window).width() > 857) {
					text = text.substring(0, 18) + '...';
					$(this).text(text);
				  }
		  });
		},
		
		changeForm : function(item){
			PharmacyResultSelfService.changeFormParam = true;
			PharmacyResultSelfService.changeBrandParam = false;
			PharmacyResultSelfService.changeStrengthParam = false;
			PharmacyResultSelfService.changePackageParam = false;
			PharmacyResultSelfService.changeQuantityParam = false;
			
			let index = $(this).children("option:selected").attr("data-index");
			PharmacyResultSelfService.formSelection = index;
			PharmacyResultSelfService.populateForms();
			PharmacyResultSelfService.drugFormParam = $(this).children("option:selected").val();
			PharmacyResultSelfService.populateDrugPackageFormDescription();
			PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header','tmpl_drug_selection_details_in_header');
			PharmacyResultSelfService.getDrugPriceDetailsByNDCNAuthDetails(item);
		},
		
		changeStrength : function(item){
			PharmacyResultSelfService.changeStrengthParam = true;
			PharmacyResultSelfService.changeBrandParam = false;
			PharmacyResultSelfService.changeFormParam = false;
			PharmacyResultSelfService.changePackageParam = false;
			PharmacyResultSelfService.changeQuantityParam = false;
						
			let index = $(this).children("option:selected").attr("data-index");
			PharmacyResultSelfService.strengthSelection = index;
			PharmacyResultSelfService.populateStrengths();
			PharmacyResultSelfService.drugStrengthParam = $(this).children("option:selected").val();
			PharmacyResultSelfService.populateDrugPackageFormDescription();
			PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header','tmpl_drug_selection_details_in_header');
			PharmacyResultSelfService.getDrugPriceDetailsByNDCNAuthDetails(item);
		},
		
		changePackage : function(item){
			PharmacyResultSelfService.changePackageParam = true;
			PharmacyResultSelfService.changeBrandParam = false;
			PharmacyResultSelfService.changeStrengthParam = false;
			PharmacyResultSelfService.changeFormParam = false;
			PharmacyResultSelfService.changeQuantityParam = false;
			
			let index = $(this).children("option:selected").attr("data-index");
			PharmacyResultSelfService.packageSelection = index;
			
			PharmacyResultSelfService.drugPackageParam = $(this).children("option:selected").val();
			PharmacyResultSelfService.showPackageIndicatorParam = $(this).children("option:selected").attr("data-packageIndicator");
			PharmacyResultSelfService.drugNDCIDParam = $(this).children("option:selected").attr("data-optionNDCVal");
			
			PharmacyResultSelfService.populateDrugPackageFormDescription();
			PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header','tmpl_drug_selection_details_in_header');
			PharmacyResultSelfService.getDrugPriceDetailsByNDCNAuthDetails(item);
		},
		
		populateBrands : function(){
			$("#filter_brand").empty();
			var isPricesDisplayedInfoDone = false;
			PharmacyResultSelfService.drugAdditionalInformationPre = "";
			PharmacyResultSelfService.drugAdditionalInformationDrugName = "";
			PharmacyResultSelfService.drugAdditionalInformationPost = "";			
			var brandCount = 0;
			PharmacyResultSelfService.dataSet.items.forEach(PharmacyResultSelfService.populateBrand);
			
			for(var i = 0; i < PharmacyResultSelfService.dataSet.items.length; i++) {
				var item = PharmacyResultSelfService.dataSet.items[i];

				if(item.drugType == "BRAND") {

					if (isPricesDisplayedInfoDone === false){
						PharmacyResultSelfService.drugAdditionalInformationPre = "Prices displayed are for ";
						PharmacyResultSelfService.drugAdditionalInformationDrugName = PharmacyResultSelfService.drugBrandParam;
						PharmacyResultSelfService.drugAdditionalInformationDrugNameModal = PharmacyResultSelfService.drugBrandParam;
						PharmacyResultSelfService.drugAdditionalInformationPost = "";
						isPricesDisplayedInfoDone = true;						
					}

					if (PharmacyResultSelfService.drugBrandParam.includes("GENERIC") || PharmacyResultSelfService.drugBrandParam.includes(" (Generic)")) {
						PharmacyResultSelfService.drugAdditionalInformationPost+= (brandCount == 0) ? ". Generic of " + item.drugName : ", " + item.drugName;
					}

					brandCount++;

				} else if(item.drugType == "GENERIC" && (!PharmacyResultSelfService.currentH1BrandName || PharmacyResultSelfService.currentH1BrandName === '')) {
					PharmacyResultSelfService.currentH1BrandName = item.drugName;					
				}

			}

			// Only a generic - no brand...
			if (brandCount == 0) {
				PharmacyResultSelfService.drugAdditionalInformationPre = "Prices displayed are for ";
				PharmacyResultSelfService.drugAdditionalInformationDrugName = PharmacyResultSelfService.drugBrandParam;
				PharmacyResultSelfService.drugAdditionalInformationDrugNameModal = PharmacyResultSelfService.drugBrandParam;
				isPricesDisplayedInfoDone = true;					
			}	

			// populateForms
			PharmacyResultSelfService.populateForms();
		},
		
		populateBrand : function(item, index){
			var drugNameStr = (item.drugType == "GENERIC") ? item.drugName + " (Generic)" : item.drugName;
			if(index == PharmacyResultSelfService.brandSelection && PharmacyResultSelfService.changeBrandParam == false){
				PharmacyResultSelfService.drugBrandParam = drugNameStr;
			}
			var remark_html = '';
			remark_html += COSTCO.util.tmpl('tmpl_brand_selection', {
				currentIndex: index,
				selectState: index == PharmacyResultSelfService.brandSelection ? "selected='selected'" : '',
				optionText: drugNameStr,
				optionValue: drugNameStr,
            });
			$('#filter_brand').append(remark_html);
		},
		
		populateForms : function(){
			$("#filter_form").empty();
			PharmacyResultSelfService.dataSet.items[PharmacyResultSelfService.brandSelection].forms.forEach(PharmacyResultSelfService.populateForm);
			//populateStrength
			PharmacyResultSelfService.populateStrengths();
		},
		
		populateForm : function(item, index){
			if(item.isDefault == true && PharmacyResultSelfService.changeFormParam == false){
				PharmacyResultSelfService.formSelection = index;
				PharmacyResultSelfService.drugFormParam = item.form;
			}
			var remark_html = '';
			remark_html += COSTCO.util.tmpl('tmpl_form_selection', {
				selectState: index == PharmacyResultSelfService.formSelection ? "selected='selected'" : '',
				currentIndex: index,
				optionText: item.form,
				optionValue: item.form,
            });
			$('#filter_form').append(remark_html);
		},
		
		populateStrengths : function(){
			$("#filter_strength").empty();
			$("#filter_strength").removeAttr("disabled");
			PharmacyResultSelfService.dataSet.items[PharmacyResultSelfService.brandSelection].forms[PharmacyResultSelfService.formSelection].strengths.forEach(PharmacyResultSelfService.populateStrength);
			$("#filter_quantity").empty();
			$("#filter_package").empty();
			$("#filter_package").removeAttr("disabled");
			PharmacyResultSelfService.dataSet.items[PharmacyResultSelfService.brandSelection].forms[PharmacyResultSelfService.formSelection].strengths[PharmacyResultSelfService.strengthSelection].packageDescriptions.forEach(PharmacyResultSelfService.populatePackage);
			PharmacyResultSelfService.dataSet.items[PharmacyResultSelfService.brandSelection].forms[PharmacyResultSelfService.formSelection].strengths[PharmacyResultSelfService.strengthSelection].packageDescriptions.forEach(PharmacyResultSelfService.populateNDCId);
			PharmacyResultSelfService.dataSet.items[PharmacyResultSelfService.brandSelection].forms[PharmacyResultSelfService.formSelection].strengths[PharmacyResultSelfService.strengthSelection].packageDescriptions[0].quantities.forEach(PharmacyResultSelfService.populateQuantity);
			
			($("#filter_strength")[0].options.length == 0) ? $("#filter_strength").attr("disabled","disabled") : "";
			($("#filter_package")[0].options.length == 0) ? $("#filter_package").attr("disabled","disabled") : "";
			
		},
		
		populateStrength : function(item, index){
			if(item.isDefault == true && PharmacyResultSelfService.changeStrengthParam == false){
				PharmacyResultSelfService.strengthSelection = index;
				PharmacyResultSelfService.drugStrengthParam = item.strengthValue;
			}
			var remark_html = '';
			if(!(/^ *$/.test(item.strengthValue))) {
				remark_html += COSTCO.util.tmpl('tmpl_strength_selection', {
					selectState: index == PharmacyResultSelfService.strengthSelection ? "selected='selected'" : '',
					currentIndex: index,
					optionText: item.strengthValue,
					optionValue: item.strengthValue,
	            });
			}
			$('#filter_strength').append(remark_html);
		},
						
		populatePackage : function(item, index){
			
			if(item.isDefault == true && PharmacyResultSelfService.changePackageParam == false){
				PharmacyResultSelfService.packageSelection = index;
				PharmacyResultSelfService.drugPackageParam = item.packageDescription;
				PharmacyResultSelfService.showPackageIndicatorParam = item.showPackageIndicator;
				PharmacyResultSelfService.populateDrugPackageFormDescription();
				PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header','tmpl_drug_selection_details_in_header');
			} 
			var optionValue = item.packageDescription;
			var optionText = item.packageDescription;
			var optionPackageIndicator = item.showPackageIndicator;
			var optionNDCVal = item.ndc;
			
			var remark_html = '';
			if(!(/^ *$/.test(item.packageDescription))) {
				remark_html += COSTCO.util.tmpl('tmpl_package_selection', {
					selectState: index == PharmacyResultSelfService.packageSelection ? "selected='selected'" : '',
					currentIndex: index,
					optionText: optionText,
					optionPackageIndicator:optionPackageIndicator,
					optionNDCVal:optionNDCVal,
					optionValue: optionValue,
	            });
			}
			$('#filter_package').append(remark_html);
		},
		
		populateNDCId : function(item, index){
			if((item.isDefault == true || PharmacyResultSelfService.changeStrengthParam == true || PharmacyResultSelfService.changePackageParam == true || PharmacyResultSelfService.changeFormParam == true) && item.packageDescription === PharmacyResultSelfService.drugPackageParam) {
				PharmacyResultSelfService.drugNDCIDParam = item.ndc;
			}
		},
		
		populateQuantity : function(item, index){
			if(item.isDefault == true && PharmacyResultSelfService.changeQuantityParam == false){
				PharmacyResultSelfService.quantitySelection = index;
				PharmacyResultSelfService.drugQuantityParam = item.quantity;
				PharmacyResultSelfService.populateDrugPackageFormDescription();
				PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header','tmpl_drug_selection_details_in_header');
			}
			var optionValue = item.quantity;
			var optionText = item.quantity;
			var remark_html = '';
			remark_html += COSTCO.util.tmpl('tmpl_quantity_selection', {
				selectState: index == PharmacyResultSelfService.quantitySelection ? "selected='selected'" : '',
				currentIndex: index,
				optionText: optionText,
				optionValue: optionValue,
            });
			$('#filter_quantity').append(remark_html);
		},
		
		populateDrugPackageFormDescription : function() {
			
			if(PharmacyResultSelfService.showPackageIndicatorParam){
				if(PharmacyResultSelfService.drugFormParam == 'Miscellaneous'){
					if($.trim(PharmacyResultSelfService.drugStrengthParam) == ''){
						PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugPackageParam;
					}else {
						PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugPackageParam + ", "  + PharmacyResultSelfService.drugStrengthParam;
					}
				}else{
					if($.trim(PharmacyResultSelfService.drugStrengthParam) == ''){
						PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugFormParam + ", " + PharmacyResultSelfService.drugPackageParam ;
					} else {
						PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugFormParam + ", " + PharmacyResultSelfService.drugPackageParam + ", "  + PharmacyResultSelfService.drugStrengthParam;
					}
					
				}
			} else{
				if((PharmacyResultSelfService.drugFormParam == 'Tablet' || PharmacyResultSelfService.drugFormParam == 'Capsule') && PharmacyResultSelfService.drugQuantityParam > 1){
					if($.trim(PharmacyResultSelfService.drugStrengthParam) == ''){
						PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugQuantityParam + " " + PharmacyResultSelfService.drugFormParam.toLowerCase() + "s";
					}else{
						PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugStrengthParam +", " +PharmacyResultSelfService.drugQuantityParam + " " + PharmacyResultSelfService.drugFormParam.toLowerCase() + "s";
					}
				}else {
					if($.trim(PharmacyResultSelfService.drugStrengthParam) == ''){
						PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugQuantityParam + " " + PharmacyResultSelfService.drugFormParam.toLowerCase();
					}else{
						PharmacyResultSelfService.drugPackageOrFormParam = PharmacyResultSelfService.drugStrengthParam +", " +PharmacyResultSelfService.drugQuantityParam + " " + PharmacyResultSelfService.drugFormParam.toLowerCase() ;
					}
				}
			}
			
		},
		
		printDrugInformationInHeader : function(divId, tmplId){
			
			let h1BrandName = "";

			// Only change the H1 heading if this is a fresh/ new search or if the brand drop down has changed, 
			// else leave the heading as it is...
			if (PharmacyResultSelfService.getUrlParameter('drugNameParam') && PharmacyResultSelfService.isFreshSearch) {
				h1BrandName = PharmacyResultSelfService.getUrlParameter('drugNameParam').replaceAll('+', ' ');
				PharmacyResultSelfService.currentH1BrandName = h1BrandName;
				PharmacyResultSelfService.isFreshSearch = false;
				$('#cmppBreadcrumbDrugName').text(h1BrandName);
			} else if (PharmacyResultSelfService.changeBrandParam){
				h1BrandName = PharmacyResultSelfService.drugBrandParam;
				PharmacyResultSelfService.currentH1BrandName = h1BrandName;
			} else {
				h1BrandName = PharmacyResultSelfService.currentH1BrandName;
			}			
			
			// Where the drug name in the H1 and the drug name in the line below (PharmacyResultSelfService.drugAdditionalInformationDrugName) match
			// Then special rules apply...
			if (PharmacyResultSelfService.drugAdditionalInformationDrugName.toUpperCase().includes(h1BrandName.toUpperCase())) {
				PharmacyResultSelfService.drugAdditionalInformationPre = "";
				PharmacyResultSelfService.drugAdditionalInformationDrugName = "";
				if (PharmacyResultSelfService.drugAdditionalInformationPost.includes(". Generic of")) {
					PharmacyResultSelfService.drugAdditionalInformationPost = PharmacyResultSelfService.drugAdditionalInformationPost.substring(2);
				}
			}			
			
			var remark_html = '';
			$('#'+divId).html(remark_html);
			remark_html += COSTCO.util.tmpl(tmplId, {
				drugForm: PharmacyResultSelfService.drugFormParam  ,
				drugGenericBrand: PharmacyResultSelfService.drugGenericBrandParam,
				drugAdditionalInformationPre: PharmacyResultSelfService.drugAdditionalInformationPre,
				drugAdditionalInformationDrugName: PharmacyResultSelfService.drugAdditionalInformationDrugName,
				drugAdditionalInformationPost: PharmacyResultSelfService.drugAdditionalInformationPost,				
				drugStrength: PharmacyResultSelfService.drugStrengthParam  ,
				drugStrengthPackageOrForm: PharmacyResultSelfService.drugPackageOrFormParam,
				drugQuantity: PharmacyResultSelfService.drugQuantityParam,
				drugAdditionalInformationDrugNameModal: PharmacyResultSelfService.drugAdditionalInformationDrugNameModal,
            });
			$('#'+divId).html(remark_html);
			$('#cmppDrugBrandTitle').text(h1BrandName);
		},
		
		
		/**
		 * getAutoSuggestedDrugAuthDetails is a method is used for getting the API End-Point and Token Information from the back-end.
		 * This method hit an external API for getting the auto suggested drug list for a keyword provided in the text field
		 * This method invokes a method getAutoSuggestedDrugNamesByKeyword to display the results
		 * Condition : If the character length is more than 2
		 * Ex: 'fl' >> Flovent HFA, Fluad etc..!
		 * @param : keyword
		 */	
		getAutoSuggestedDrugAuthDetails: function(keyword){
			let CMPP_DRUG_SEARCH_END_POINT = 'CMPP_DRUG_SEARCH_END_POINT';
			let apiURL = '';
			let token = '';
			let displayError = '';
			let responseTimeout = 0;
			$('#cmppDrugNameTextID').remove('error');
			$('.cmppAutoSuggest').hide();
			//Setting the empty data to the respective #div_drugNameAutoSuggestionsError before inserting the data
			$('#div_drugNameAutoSuggestionsError').html(displayError);
			$.get('/AjaxCostcoCMPPDrugAuthDetailsLookupView?action=token&apiName='+CMPP_DRUG_SEARCH_END_POINT)
			.done(function(data) {
				let object = JSON.parse(data);
				apiURL = object.apiURL;
				token = object.token;
				responseTimeout = object.responseTimeout;
				jQuery.ajax({
				    url: apiURL+keyword,
				    type: 'GET',
				    timeout : responseTimeout,
				    headers: {
				    	"Content-Type": "application/json",
				    	"Accept": "application/json",
				    	'api-version': object.apiVersionNumber
				    },
				    beforeSend : function(xhr) {
				        xhr.setRequestHeader( 'Authorization', 'Bearer ' +token);
				    },
				    success: function(response) {
				    	if(response.length > 0){
				    		PharmacyResultSelfService.getAutoSuggestedDrugNamesByKeyword(response);
				    	}else{
				    		$('#cmppDrugNameTextID').addClass('error');
							$('#div_drugNameAutoSuggestionsError').addClass('error');
							displayError += COSTCO.util.tmpl('templ_drug_names_suggestions_error_display', {});
							$('#div_drugNameAutoSuggestionsError').html(displayError);
							$('.cmppAutoSuggest').hide();
				    	}
				    },
				    error: function(xhr, ajaxOptions, thrownError) {
				        console.log("Ajax Error>>"+thrownError);
				    }
				});
			});
		},
		
		/**
	     * Displays suggested drug list by the keyword provided by the user in the search text field
	     */
		getAutoSuggestedDrugNamesByKeyword : function(data){
			let displaySuggestedNames = '';
			let displayError = '';
			let errroText = '';
			$('#cmppDrugNameTextID').removeClass('error');
			$('.cmppAutoSuggest').hide();
			$('#div_drugNameAutoSuggestions').html(displaySuggestedNames);
			$('#div_drugNameAutoSuggestionsError').html(displayError);
			displaySuggestedNames = "<ul id='autoSuggestionsId'>";	
			for (let i in data){
				displaySuggestedNames += COSTCO.util.tmpl('templ_drug_names_suggestions_display', {
					drugId: data[i].drugIdentifier,
					drugName: data[i].drugName,
                });
			}
			displaySuggestedNames = displaySuggestedNames+'</ul>';
			$('#div_drugNameAutoSuggestions').html(displaySuggestedNames);
			$('.cmppAutoSuggest').show();
			$("#cmppDrugNameTextID").keyup(function() {
				$('#drugNameParam').val($(this).val());
				$('#drugIdentifierParam').val($('ul#autoSuggestionsId li:first').attr('id'));
			});
			$('#autoSuggestionsId li').keyup(function(e) {
				if(e.keyCode == 13) {
					$('#drugNameParam').val($(this).text());
					$('#drugIdentifierParam').val($(this).attr('id'));
					$('#cmppDrugNameTextID').val($(this).text());
					$('.cmppAutoSuggest').hide();
					$('#cmppSubmitId').click();
				}
			});
			$('#autoSuggestionsId li.selected').keyup(function(e) {
				if(e.keyCode == 13) {
					$('#drugNameParam').val($(this).text());
					$('#drugIdentifierParam').val($(this).attr('id'));
					$('#cmppDrugNameTextID').val($(this).text());
					$('.cmppAutoSuggest').hide();
					$('#cmppSubmitId').click();
				}
			});
			$('#autoSuggestionsId li').click(function() {
				$('#drugNameParam').val($(this).text());
				$('#drugIdentifierParam').val($(this).attr('id'));
				$('#cmppDrugNameTextID').val($(this).text());
				$('.cmppAutoSuggest').hide();
				$('#cmppSubmitId').click();
			});
		},
		
		getDrugPriceDetailsByNDCNAuthDetails : function(){
			let CMPP_DRUG_SEARCH_END_POINT = 'CMPP_DRUG_PRICE_DETAILS_BY_PARAMS_END_POINT';
			let apiURL = '';
			let token = '';
			let responseTimeout = 0;
			let displayError = '';
			$.get('/AjaxCostcoCMPPDrugAuthDetailsLookupView?action=token&apiName='+CMPP_DRUG_SEARCH_END_POINT)
			.done(function(data) {
				PharmacyResultSelfService.toggleDrugPricingAndSpecs('cmppPricingTab', 'cmppPricingDetails');
				let remark_html = '';
				remark_html = '<div class="pharmacy-result-container">';
				remark_html += COSTCO.util.tmpl('tmpl_ajax_loader', {});
				remark_html += '</div>';
				$('#div_DrugNetworkResultsDisplay').addClass('ajax-busy');
				$('#div_DrugNetworkResultsDisplay').html(remark_html);
				$('#div_DrugNetworkResultsDisplay .cmpp-loader').show();
				let object = JSON.parse(data);
				apiURL = object.apiURL;
				token = object.token;
				responseTimeout = object.responseTimeout;
				let drugIdentifier	= PharmacyResultSelfService.getUrlParameter('drugIdentifierParam');
				let drugNdc	= PharmacyResultSelfService.drugNDCIDParam;
				console.log('drugNdc: '+drugNdc);
				jQuery.ajax({
				    url: apiURL+PharmacyResultSelfService.drugNDCIDParam+'?quantity='+PharmacyResultSelfService.drugQuantityParam+'&zipCode='+PharmacyResultSelfService.zipCode,
				    type: 'GET',
				    timeout : responseTimeout,
				    headers: {
				    	"Content-Type": "application/json",
				    	"Accept": "application/json",
				    	'api-version': object.apiVersionNumber
				    },
				    beforeSend : function(xhr) {
				        xhr.setRequestHeader( 'Authorization', 'Bearer ' +token);
				        if ($('#drug-details-info').length > 0) $('#div_DrugDetails').children().last().hide();
				    },
				    success: function(response) {
				    	
				    	let isPetMed = false;
				    	response.items.forEach(function(item) {
				    		if (item.isPetMed === true) {
				    			isPetMed = true;
				    		}
				    	});
				    	
				    	PharmacyResultSelfService.getDrugPriceDetailsByNDCNParams(response);
						$('#div_DrugNetworkResultsDisplay').removeClass('ajax-busy');
						$('#div_DrugNetworkResultsDisplay .cmpp-loader').hide();
				    	
						// So long as this is not pet medication then go ahead
						// and make the call to get drug information...
						// 
				    	if (isPetMed === false) {
							PharmacyResultSelfService.getDrugDetailsInfo(token, drugNdc);
							$("#cmppDrugSpecificationsTab").show();
				    	} else {
				    		$("#cmppDrugSpecificationsTab").hide();
				    	}
				    	
						if ($('.link-membership-pet-meds').length > 0) {
							COSTCO.LinkMembership.init();
						}
						
				    },
				    error: function(xhr, ajaxOptions, thrownError) {
						console.log("Ajax Error>>"+thrownError);
						$('#div_DrugNetworkResultsDisplay').removeClass('ajax-busy');
						$('#div_DrugNetworkResultsDisplay .cmpp-loader').hide();
				    }
				});
			});
		},
		/**
		 * Calling Elsevier service to get detal drug information
		 * @param {*} token 
		 * @param {*} nationalDrugCode 
		 */
		getDrugDetailsInfo: function(token, nationalDrugCode) {
			let remark_html = '';
			remark_html = '<div class="pharmacy-result-container">';
			remark_html += COSTCO.util.tmpl('tmpl_ajax_loader', {});
			remark_html += '</div>';
			$('#div_DrugDetails').addClass('ajax-busy');
			$('#div_DrugDetails').html(remark_html);
			$('#div_DrugDetails .cmpp-loader').show();
			$.ajax({
				url: '/AjaxGetCMPPDrugInfoCmd' +'?action='+token+ '&drugIdentifier='+nationalDrugCode,
				type: 'POST',
				dataType: 'json',
				success: function(data, textStatus, xhr){
					try {
						let drugInfoResponse = JSON.parse(data.drugInfoResponse);
						if (data["http reponse status code"] === "200" && drugInfoResponse) {
							//success process returns the result in a JSON object.
							remark_html = '';
							remark_html += COSTCO.util.tmpl('templ_drug_details_info_display', {
								descriptionHeader: drugInfoResponse["DescriptionHeader"],
								descriptionBody: drugInfoResponse["Description"],
								contraindicationsHeader: drugInfoResponse["ContraindicationsHeader"],
								contraindicationsBody: drugInfoResponse["Contraindications"],
								administrationHeader: drugInfoResponse["AdministrationHeader"],
								administrationBody: drugInfoResponse["Administration"],
								missedDoseHeader: drugInfoResponse["MissedDoseHeader"],
								missedDoseBody: drugInfoResponse["MissedDose"],
								interactionsHeader: drugInfoResponse["InteractionsHeader"],
								interactionsBody: drugInfoResponse["Interactions"],
								monitoringHeader: drugInfoResponse["MonitoringHeader"],
								monitoringBody: drugInfoResponse["Monitoring"],
								sideEffectsHeader: drugInfoResponse["SideEffectsHeader"],
								sideEffectsBody: drugInfoResponse["SideEffects"],
								storageHeader: drugInfoResponse["StorageHeader"],
								storageBody: drugInfoResponse["Storage"],	
							});
							$('#div_DrugDetails').append(remark_html);
							$('#div_DrugDetails').removeClass('ajax-busy');
							$('#div_DrugDetails .cmpp-loader').hide();
							console.log('ELSEVIER - successfully retrieving info drug')
						} else {
							console.error('Error: ELSEVIER - retrieving info drug');
							$('#div_DrugDetails').removeClass('ajax-busy');
							$('#div_DrugDetails .cmpp-loader').hide();
						}
					} catch (e) {
						console.warn('Warning: ELSEVIER - retrieving info drug - no drug info');
						$('#div_DrugDetails').removeClass('ajax-busy');
						$('#div_DrugDetails .cmpp-loader').hide();
					}
					
				},
				failure: function(data, textStatus, xhr){
					console.log("Ajax Error>>"+thrownError);
					$('#div_DrugDetails').removeClass('ajax-busy');
					$('#div_DrugDetails .cmpp-loader').hide();
				}
			});
		},
		/**
	     * Function is used to retrieve the price details and print in the widget
	     */
		getDrugPriceDetailsByNDCNParams : function(data){
			let crossSellEspot = '';
			let remark_html = '';
			remark_html = '<div class="pharmacy-result-container">';
			remark_html += COSTCO.util.tmpl('tmpl_ajax_loader', {});
			let countOfNoPricesToDisplay = 0;
			if(data.items.length == 0){
				remark_html += COSTCO.util.tmpl('templ_drug_price_details_hero_marketing_1_display_no_pharmacies', {noPharmaciesMsg : messages.CMPP_NO_PHARMACIES_AVAILABLE});
			}
			//loop to grab the number of items with networname including 'Costco'
			let crossSellEspotIndex = -1;
			for (var i in data.items){
               if(data.items[i].networkName.includes('Costco')){
            	   crossSellEspotIndex =  crossSellEspotIndex+1;
               }
           }
			for (var i in data.items) {
				let displayNetwork = true;
				if(data.items[i].networkName != messages.CMPP_COSTCO_MAIL_ORDER && data.items[i].mailOrderLocation === true) {
					displayNetwork = false;
				}
				if(i == PharmacyResultSelfService.firstMarketingContentIndex){
					remark_html += COSTCO.util.tmpl('templ_drug_price_details_hero_marketing_1_display', {});
				}
				if(crossSellEspotIndex == -1){ // No network with Costco result - Cross sell Espot Should be displayed below the hero_marketing_epsot 
					remark_html += '<div class="cross-sell-espot-class" style="display:none;"></div>';
				}
				if(i == PharmacyResultSelfService.secondMarketingContentIndex){
					remark_html += COSTCO.util.tmpl('templ_drug_price_details_hero_marketing_2_display', {});
				}
				if(displayNetwork) {
					if(typeof data.items[i].isPetMed === 'undefined' || data.items[i].isPetMed == false || (data.items[i].isPetMed == true && data.items[i].showPrice == true )){
						//Insert commas into the numeric string at appropriate places to format it with thousands separators.
						let networkPrice = '$' + data.items[i].networkPrice.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
						if(data.items[i].mailOrderLocation == true){
							remark_html += COSTCO.util.tmpl('templ_drug_networks_get_started_results_display', {
			        	        networkName: data.items[i].networkName,
			        	        networkLogoURL: data.items[i].logoUrl+'?placeholderForMissingLogo=true',
			        	        networkDrugPrice: (data.items[i].isPetMed == true) ? this.getDrugPriceTextForLoggedInUser('<h2>' + networkPrice + '</h2>') : '<h2>' + networkPrice + '</h2>',
			        	        fromPage: encodeURIComponent(location.pathname),
			        	        petMedPriceColumnWidth: (data.items[i].isPetMed == true) ? 'col-md-5 col-lg-5 col-xl-5' : 'col-md-4 col-lg-4 col-xl-4',
			        	        petMedOnlineLinkColumnWidth: (data.items[i].isPetMed == true) ? 'col-md-3 col-lg-3 col-xl-3' : 'col-md-4 col-lg-4 col-xl-4'
							  });
						
						} else {
							remark_html += COSTCO.util.tmpl('templ_drug_networks_results_display', {
			        	        networkName: data.items[i].networkName,
			        	        networkLogoURL: data.items[i].logoUrl+'?placeholderForMissingLogo=true',
			        	        networkDrugPrice: (data.items[i].isPetMed == true) ? this.getDrugPriceTextForLoggedInUser('<h2>' + networkPrice + '</h2>') : '<h2>' + networkPrice + '</h2>',
			        	        networkId: data.items[i].id,
			        	        fromPage: encodeURIComponent(location.pathname),
		        	        	customURL: data.items[i].customURL,
		        	        	customURLText: data.items[i].customURLText,
		        	        	petMedPriceColumnWidth: (data.items[i].isPetMed == true) ? 'col-md-5 col-lg-5 col-xl-5' : 'col-md-4 col-lg-4 col-xl-4',
		        	        	petMedOnlineLinkColumnWidth: (data.items[i].isPetMed == true) ? 'col-md-3 col-lg-3 col-xl-3' : 'col-md-4 col-lg-4 col-xl-4'
							  });
						}
					} else {
						if(data.items[i].mailOrderLocation == true){
							if(typeof data.items[i].showAltPriceImage === 'undefined' || data.items[i].showAltPriceImage == false){
								remark_html += COSTCO.util.tmpl('templ_drug_networks_get_started_results_petMedText_display', {
				        	        networkName: data.items[i].networkName,
				        	        networkLogoURL: data.items[i].logoUrl+'?placeholderForMissingLogo=true',
				        	        networkDrugPrice: this.getDrugPriceTextForLoggedInUser(data.items[i].altPriceText),
				        	        networkId: data.items[i].id,
				        	        fromPage: encodeURIComponent(location.pathname),
								  });
							}else {
								remark_html += COSTCO.util.tmpl('templ_drug_networks_get_started_results_petMedImage_display', {
				        	        networkName: data.items[i].networkName,
				        	        networkLogoURL: data.items[i].logoUrl+'?placeholderForMissingLogo=true',
				        	        networkDrugPrice: this.getDrugPriceTextForLoggedInUser(data.items[i].altPriceImageUrl),
				        	        networkId: data.items[i].id,
				        	        fromPage: encodeURIComponent(location.pathname),
								  });
							}
						} else {
							if(typeof data.items[i].showAltPriceImage === 'undefined' || data.items[i].showAltPriceImage == false){
								
								remark_html += COSTCO.util.tmpl('templ_drug_networks_results_petMedText_display', {
				        	        networkName: data.items[i].networkName,
				        	        networkLogoURL: data.items[i].logoUrl+'?placeholderForMissingLogo=true',
				        	        networkDrugPrice: this.getDrugPriceTextForLoggedInUser(data.items[i].altPriceText),
				        	        networkId: data.items[i].id,
				        	        fromPage: encodeURIComponent(location.pathname),
				        	        customURL: (data.items[i].isPetMed == true && data.items[i].showPrice == false && data.items[i].networkName == messages.CMPP_PETMED_NETWORK_VETSOURCE) ? data.items[i].customURL : null,
					        	    customURLText: (data.items[i].isPetMed == true && data.items[i].showPrice == false && data.items[i].networkName == messages.CMPP_PETMED_NETWORK_VETSOURCE) ? data.items[i].customURLText : null,
								  });
								  countOfNoPricesToDisplay++;
							}else {
								remark_html += COSTCO.util.tmpl('templ_drug_networks_results_petMedImage_display', {
				        	        networkName: data.items[i].networkName,
				        	        networkLogoURL: data.items[i].logoUrl+'?placeholderForMissingLogo=true',
				        	        networkDrugPriceURL: data.items[i].altPriceImageUrl,
				        	        networkDrugPrice: this.getDrugPriceTextForLoggedInUser(data.items[i].altPriceImageUrl),
				        	        networkId: data.items[i].id,
				        	        fromPage: encodeURIComponent(location.pathname),
								  });
							}
						}
					}
				}
				//  Network name has 1 or 2 Costco result, Cross sell Espot should be displayed below the Costco result
				if(i == crossSellEspotIndex && (crossSellEspotIndex != -1)){ 
					remark_html += '<div class="cross-sell-espot-class" style="display:none;"></div>';
				}
			}
			PharmacyResultSelfService.readESPOT_By_NDCN(data);
			remark_html = remark_html+'</div>';
			$('#div_DrugNetworkResultsDisplay').html(remark_html);
			
			isPricingDataToDisplay = true

			if(data.items.length == 0) {
				isPricingDataToDisplay = false;
			} else if (data.items.length == countOfNoPricesToDisplay){
				isPricingDataToDisplay = false;
			}

			if (isPricingDataToDisplay == false) {
				PharmacyResultSelfService.drugAdditionalInformationPre = "";
				PharmacyResultSelfService.drugAdditionalInformationPost = "";
				PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_header','tmpl_drug_selection_details_in_header');
			}	
			
		},
		toggleDrugPricingAndSpecs: function(buttonId, drugDetailsType){
			  var i, tabcontent, tablinks;

			  tabcontent = $("#cmpp_tabs .tabcontent");
			  for (i = 0; i < tabcontent.length; i++) {
			    tabcontent[i].style.display = "none";
			  }

			  tablinks = $(".cmppTabs .tablinks");
			  for (i = 0; i < tablinks.length; i++) {
			    tablinks[i].className = tablinks[i].className.replace(" active", "");
			    tablinks[i].ariaExpanded = "false";
			  }

			  $("#" + drugDetailsType).attr("style","display:block;");
			  $("#" + buttonId)[0].className += " active";
			  $("#" + buttonId)[0].ariaExpanded = "true";
		},
		
		//Adding Espots to the CMPP Result page
		//Four different Espots needs to be displayed depending on the value from the response
		readESPOT_By_NDCN:function(data){
			let espot1Name ='';
            let complianceEspot ='';
            let crossSellEspotName = '';
            let crossSellEspotValue = ''
            let espot3Name ='';
            let categoryEspot3 ='';
            let espot4Name = '';
			let categoryEspot4 = '';
			let responseData='';
            if(data.espots!=null){
			if(data.espots.espot1){
            	complianceEspot = data.espots.espot1;
            	espot1Name = "cmppPharmacy_".concat(complianceEspot);
            }
            if(data.espots.espot2){
            	crossSellEspotValue = data.espots.espot2;
            	crossSellEspotName = "cmppPharmacy_".concat(crossSellEspotValue);
            }
            if(data.espots.espot3){
            	categoryEspot3 = data.espots.espot3;
            	espot3Name = "cmppPharmacy_".concat(categoryEspot3);
            }
            if(data.espots.espot4){
            	categoryEspot4 = data.espots.espot4;
            	espot4Name = "cmppPharmacy_".concat(categoryEspot4);
            }
            //Display Espots depending on the response 
             if((data.items.length !== 0)){ 
            	 jQuery.ajax({
				    url: '/CostcoESpotApiRead?ems1Name='+espot1Name+'&ems2Name='+crossSellEspotName+'&ems3Name='+espot3Name+'&ems4Name='+espot4Name,
				    type: 'GET', 
				    headers: {"Content-Type":"application/html","Accept": "application/html"},
				    success: function(ESpotcontentstr) {
				    	let ESpotcontent = $.parseHTML(DOMPurify.sanitize(ESpotcontentstr)); // Changing the String Response to object
				    	let remark_html = '';
				    	let complianceEspotContent = '';
				    	let crossSellEspotContent = '';
				    	let categoryEspot3Content = '';
				    	let categoryEspot4Content = '';
				    	 if(complianceEspot && (typeof $(ESpotcontent).find('#ems1Content').html() !== 'undefined')){ //Checks if Compliance message Espot has a value and Content.
				    	   remark_html = '<div class="pharmacy-espot-container">';
				    	   complianceEspotContent = $(ESpotcontent).find('#ems1Content').html();
                           remark_html += complianceEspotContent;
                           remark_html = remark_html+'</div>';
                           $('#div_DrugNetworkEspotDisplay').html(remark_html); 
				    	 }
				    	 else{
                           $('#div_DrugNetworkEspotDisplay').hide();
                        }
				    	 if(crossSellEspotValue && (typeof $(ESpotcontent).find('#ems2Content').html() !== 'undefined')){ // Checks if Cross Sell Espot has a value and Content.
				    		 crossSellEspotcontent = $(ESpotcontent).find('#ems2Content').html();
	                         $(".cross-sell-espot-class").html(crossSellEspotcontent); 
	                         $(".cross-sell-espot-class").show();
				    	 }else{
				    		 $(".cross-sell-espot-class").hide();
				    	 }
				    	 if(categoryEspot3 && (typeof $(ESpotcontent).find('#ems3Content').html() !== 'undefined')){ // Checks if First Categories Espot has a value and Content.
	                         remark_html = '<div class="categories-espot-container">';
	                         categoryEspot3Content = $(ESpotcontent).find('#ems3Content').html();
	                         remark_html += categoryEspot3Content;
	                         remark_html = remark_html+'</div>';
	                         $('#div_DrugNetworkCategoriesEspot1').html(remark_html); 
	                         $('#div_DrugNetworkCategoriesEspot1_mobile_view').html(remark_html); 
				    	 } else{
                            $('#div_DrugNetworkCategoriesEspot1').hide('categories-espot');
                            $('#div_DrugNetworkCategoriesEspot1_mobile_view').hide('categories-espot');
                         }
				    	 if(categoryEspot4 && (typeof $(ESpotcontent).find('#ems4Content').html() !== 'undefined')){ // Checks if Second Categories Espot has a value and Content.
	                        remark_html = '<div class="categories-espot-container">';
	                        categoryEspot4Content = $(ESpotcontent).find('#ems4Content').html();
			                remark_html += categoryEspot4Content;
			                remark_html = remark_html+'</div>';
			                $('#div_DrugNetworkCategoriesEspot2').html(remark_html); 
			                $('#div_DrugNetworkCategoriesEspot2_mobile_view').html(remark_html);
				    	 }else{
		                    $('#div_DrugNetworkCategoriesEspot2').hide('categories-espot');
		                    $('#div_DrugNetworkCategoriesEspot2_mobile_view').hide('categories-espot');
		                }
				    	
	                     
				    
				    },
				    error: function(xhr, ajaxOptions, thrownError) {
				    	console.log("Espot error");
				    }
				});

            	 
             }
           }
},

		getDrugStoreLocationsDisplay : function(byId){
			PharmacyResultSelfService.clearTemplateView('bing-map');
			PharmacyResultSelfService.clearTemplateView('costcoModalBodyData');
			$('#ShowMore').hide();
			$('#warehouse-modal-spinner').html(COSTCO.util.tmpl('tmpl_spinner'));
			let CMPP_DRUG_SEARCH_END_POINT = 'CMPP_DRUG_STORE_LOCATIONS_BY_ID_END_POINT';
			let apiURL = '';
			let token = '';
			let displayError = '';
			let responseTimeout = 0;
			$.get('/AjaxCostcoCMPPDrugAuthDetailsLookupView?action=token&apiName='+CMPP_DRUG_SEARCH_END_POINT)
			.done(function(data) {
				let object = JSON.parse(data);
				apiURL = object.apiURL;
				token = object.token;
				responseTimeout = object.responseTimeout;
				let drugIdentifier	= PharmacyResultSelfService.getUrlParameter('drugIdentifierParam');
				jQuery.ajax({
				    url: apiURL+byId+'?zipCode='+PharmacyResultSelfService.zipCode,
				    type: 'GET',
				    timeout : responseTimeout,
				    headers: {
				    	"Content-Type": "application/json",
				    	"Accept": "application/json",
				    	'api-version': object.apiVersionNumber
				    },
				    beforeSend : function(xhr) {
				        xhr.setRequestHeader( 'Authorization', 'Bearer ' +token);
				    },
				    success: function(response) {
						PharmacyResultSelfService.printDrugStoreLocationsDisplay(response);
				    },
				    error: function(xhr, ajaxOptions, thrownError) {
				    	$('#warehouse-modal-spinner').html('');
				    	console.log("Ajax Error>>"+thrownError);
				    }
				});
			});
			$(document).ready(function(){
				setTimeout(function() {
					let mapLi = $('ul#costcoModalBodyData li').length;
					let mapLiVisible = $('ul#costcoModalBodyData li:visible').length;
					if ( mapLi == mapLiVisible) {
						$('#ShowMore').hide();
					}
				}, 600);
			});
		},
		
		/**
	     * Function is used to retrieve the store location details and print in the pop-up on click View Locations link
	     */
		printDrugStoreLocationsDisplay : function(data){
			let remark_html = "";
			$('#warehouse-modal-spinner').html('');
			PharmacyResultSelfService.displayStoresOnMap(data.items);
			if(data.items.length > PharmacyResultSelfService.minStoreLocationViewLength) {
				$('#ShowMore').show();
			}else {
				$('#ShowMore').hide();
			}
			data.items.forEach(function(storeObj, i){
				let newZip = PharmacyResultSelfService.truncateZip(storeObj.zip);
				let newMiles = storeObj.distance.toFixed(2);
				remark_html += COSTCO.util.tmpl('templ_drug_store_locations_results_display', {
					storeNumber : i + 1,
					id: storeObj.id,
					storeName: storeObj.storeName,
					address1:storeObj.address1,
					address2:storeObj.address2,
					city:storeObj.city,
					state:storeObj.state,
					zip:newZip,
					telephoneNumber: typeof (storeObj.telephoneNumber) !== "undefined" && storeObj.telephoneNumber.length === 10  ? "(".concat(storeObj.telephoneNumber.substring(0,3)).concat(") ").concat(storeObj.telephoneNumber.substring(3,6)).concat("-").concat(storeObj.telephoneNumber.substring(6,10)) : "" ,
					hours:storeObj.hours,
					customAttribute1:storeObj.customAttribute1,
					customAttribute2:storeObj.customAttribute2,
					customAttribute3:storeObj.customAttribute3,
					distance:newMiles,
					setStoreCompleteAddress :  PharmacyResultSelfService.setStoreAddress(storeObj.id,storeObj.address1,"",storeObj.city,storeObj.state),
              });
			});
			$('#costcoModalBodyData').html(remark_html);
			$('#costcoModalTitleLocations').text("Find a Location");
			PharmacyResultSelfService.printDrugInformationInHeader('div_drug_selection_details_in_modal_header','tmpl_drug_selection_details_in_modal_header');
			PharmacyResultSelfService.focusOnModal();
		},
		/**
		 * Function whicch keep focus on modal
		 */
		focusOnModal : function() {
				$('#costcoModalLocations').keydown(function(e){
		        var $focusable = $(this).find("button, a, input").filter(":visible");
		        if($focusable.last().is(":focus") && (!	e.shiftKey  && e.keyCode == 9)){
		                e.preventDefault();
		                $focusable.first().focus();
		        }
		        else if($focusable.first().is(":focus") && (e.shiftKey  && e.keyCode == 9)){
		            e.preventDefault();
		            $focusable.last().focus();
		        }
			});
		},
		/**
	     * Function is used to clear the content in the Div
	     */
		clearTemplateView : function(divId){
			let clearView = '';
			$('#'+divId).html(clearView);
		},
		/**
	     * Function is used to concat the address details and push the address
	     */
		setStoreAddress : function(storeIdParam, strAdd1Param, strAdd2Param, strCityParam, strStateParam){
			let storeAddress = '';
			storeAddress = encodeURIComponent(
			[''].concat(strAdd1Param.split(' '))
			.concat(strAdd2Param.split(' '))
	        .concat(strCityParam.split(' '))
	        .concat(strStateParam)
	        .join(' '));
			PharmacyResultSelfService.setStoreAddressArr.push({
				Key:storeIdParam,
				Value:storeAddress
			});
		},
		/**
	     * Creates an instance of the BING map and stores it in the Locator object.
	     * @param  {string} mapId the BING map container id
	     * @return {void}
	     */
		displayStoresOnMap : function(locationObjects){
			try {
				
				/**
				 * Bing Map Secret Key
				 */
				var globalBingStaticKeyVar = $('#globalBingStaticKey').val();				
				
				var map = new Microsoft.Maps.Map(PharmacyResultSelfService.desktopDivId, {
					credentials: globalBingStaticKeyVar,
					mapTypeId: Microsoft.Maps.MapTypeId.road,
					enableHighDpi: true,
					liteMode: true,
					zoom: PharmacyResultSelfService.zoom,
					navigationBarMode: Microsoft.Maps.NavigationBarMode.minified,
				});
				var pins = [];
				locationObjects.forEach(function(locationObj, i){
					let location = new Microsoft.Maps.Location(locationObj.latitude, locationObj.longitude);
					let pin = new Microsoft.Maps.Pushpin(location, {
						icon: COSTCO.util.tmpl('tmpl_locator_pin', {
							number: i + 1,
							weight: PharmacyResultSelfService.weight,
							locationName: location,
						}),
						anchor: new Microsoft.Maps.Point(10.5185, 30),
			        });
			        pins.push(pin);
				}); 
				// Add the pins to the map
				map.entities.push(pins);
				
				if(locationObjects.length === 1){
					//Use Center view to scale the map to default 2 miles using zoom = 11
					map.setView({
					    center: new Microsoft.Maps.Location(locationObjects[0].latitude, locationObjects[0].longitude),
					    zoom: PharmacyResultSelfService.zoom
					});
				}else {
					// Determine a bounding box to best view the results.
			        let bounds = Microsoft.Maps.LocationRect.fromLocations(locationObjects);
			        // Use the locations from the results to calculate a bounding box.
			        map.setView({
			        	bounds: bounds,
			        });
				}
			} catch (e) {
				$(PharmacyResultSelfService.desktopDivId).html('<div tabindex="0" class="cds-u-space-pr-md cds-u-space-pl-md" style="height: 400px; background-color: #eeeeee;">'
				+'<span><p class="body-copy cds-u-space-pt-md">' + messages.COOKIE_COMPLIANCE_BING_WARNING_MESSAGE + '</p></span></div>');
			}		
		},
		/**
	     * onclick handler for the "Get Directions" link. Opens a new tab and redirects
	     * to maps.google.com using Current Location as starting addr and warehouse
	     * address as the destination address.
	     * @param  {number} index used to get the store id
	     * @return {void}
	     */
	    getStoreDirections: function(index) {
	    	let storeLocation = '';
	    	PharmacyResultSelfService.setStoreAddressArr.forEach(function(storeAddress) {
	    		if(storeAddress.Key == index){
	    			storeLocation = storeAddress.Value;
	    		}
	    	});
	    	let win = window.open(
	    			window.location.protocol + '//maps.google.com?saddr=Current+Location&daddr=' + storeLocation, '_blank');
	    	win.focus();
		},
		validateDrugForm : function(){
			let isValid = true;
			let drugIdentifierVal = $('#drugIdentifierParam').val();
			if($('#cmppDrugNameTextID').val()=="" || drugIdentifierVal=="" || 
					(typeof($('#'+drugIdentifierVal+'')[0]) !== 'undefined' &&  $('#'+drugIdentifierVal+'').attr('aria-label').toLowerCase() !== $('#cmppDrugNameTextID').val().toLowerCase())){
				
				return false;
			} 
			return isValid;
		},
	    /**
	     * Function used to identify CMPP feature is Dormant or not
	     */
	    isCMPPDormant : function() {
			$.get('/AjaxCostcoCMPPDormantCheckLookupView')
			.done(function(data) {
				try {
					let isCMPPDormantFlag = $.trim(data);
					return isCMPPDormantFlag;
				} catch (e) {
					return false;
				}
			});
	    },
	    /**
	     * Function used to display the error text in the widget
	     */
	    displayErrorMessage : function(divId, errorTextParam){
	    	let remark_html = '';
	    	remark_html += COSTCO.util.tmpl('tmpl_drug_error_display', {
	    		errorText: errorTextParam,
            });
			$('#'+divId).append(remark_html);
		},

		openMap : function(){
				$('#openCmppMap').hide();
				$('#bing-map').show();
				$('#closeCmppMap').show();
		},
		closeMap : function() {
			$('#openCmppMap').show();
			$('#bing-map').hide();
			$('#closeCmppMap').hide();
		},
		openFilter : function(){
			$('#Filter-Container').show();
			$('#openFilter').hide();
			$('#hideFilter').show();
		},
		hideFilter : function(){
			$('#Filter-Container').hide();
			$('#openFilter').show();
			$('#hideFilter').hide();
		},
		truncateZip : function(zip){
			if (zip > 5){
				return zip.substring(0,5);
			}
			else{
				return zip;
			}
		},
		truncateMiles : function(miles){
			if (miles > 5){
				return miles.substring(0,5);
			}
			else{
				return miles;
			}
		},
		checkCustomElement : function(check){
			if(check.length > 1){
				return check;
			}
			else{
				return;
			}
		},
		mileTrunc : function(miles, fixed){
			var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
			return miles.toString().match(re)[0];
		},
		openSearch: function() {
			$('#compare-price-container').show();
			$('#openSearchCMPP').hide();
		},
		
		/**
		 * Function that checks if the user is logged in and with active membership. It will return a link to the user
		 * to add the membership number. If user is not logged in at all it will return sign in link. 
		 * User needs to be signed in order to see the price for Pet Medications.
		 * */
		returnSignInForPriceHTML: function() {
			if (COSTCO.util.getMemberCookie().signedIn == true) {
				if (COSTCO.util.getMemberCookie().costcoMember == false || COSTCO.util.getMemberCookie().active == false) {
					return '<a class="link-membership-pet-meds" data-bi-tc="nav:CMPP | Add Membership Number to See Price" href="#" onclick="COSTCO.PharmacyResultSelfService.openLinkMembershipModal();return false;">' + messages.RWD_ADD_MEMBERSHIP_NUMBER_TO_SEE_PRICE + '</a>';
				}
			} else {
				return `<a data-bi-tc="nav:CMPP | Sign In to See Price" href="${window.location.protocol}//${window.location.host}/LogonForm?URL=${encodeURIComponent(window.location.href)}" > ${messages.RWD_SIGN_IN_TO_SEE_PRICE_BC} </a>`
			}
		},
		
		/**
		 *  Function return provided price or alternative text from the (Cervey) service response. Can be reused for other purposes.
		 *  Return provided string based on state of the user. 
		 * */
		getDrugPriceTextForLoggedInUser: function(drugPriceOrAlternativeText) {
			return (this.isUserLoggedInWithActiveMembership() == true) ? drugPriceOrAlternativeText : this.returnSignInForPriceHTML();
		},
		
		/**
		 * Checks for users member cookie whether user is logged in with valid membership number. Return true if is logged in and has membership that is active.  
		 * */
		isUserLoggedInWithActiveMembership: function() {
			return (COSTCO.util.getMemberCookie().signedIn == true && COSTCO.util.getMemberCookie().costcoMember == true && COSTCO.util.getMemberCookie().active == true) ? true : false;
		}, 
		
		openLinkMembershipModal: function() {
            let modalSettings = {
          dialogclasses: 'link-membership-modal',
          title: messages.RWD_ADD_MEMBERSHIP_NUMBER,
          body: COSTCO.util.tmpl('tmpl_membership_validation_pet_meds', {
            infoText: messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceModal_Body_PET_MEDS,
            membershipNumber: COSTCO.LinkMembership.memberData.number,
          }),

          primary: messages.RWD_ADD_MEMBERSHIP_NUMBER,
          secondary: messages.JS_DIALOG_CANCEL,
          primary_event: COSTCO.LinkMembership.performPrimaryValidation,
          preventClose: false,
          onshown: function() {
            $('.modal-header, .modal-body, .modal-footer').addClass('order-ajax');
            COSTCO.util.maskMembershipInput();
            $('.co-help').popover();
			// Prevent default behavior for form - Send request to server, causing page to reload navigate to new url
			$(COSTCO.LinkMembership.constants.PRIMARY_VALIDATION_FORM_ID).submit(function(event) {
			event.preventDefault()
			})
          },
          onclose: function() {},
        };

        COSTCO.dialog.showModal(modalSettings);
      },
	}
		function showMoreMap() {
			$('#ShowMore').show();
				setTimeout(function() {
					let mapLi = $('ul#costcoModalBodyData li').length;
					let mapLiVisible = $('ul#costcoModalBodyData li:visible').length;
					if ( mapLi == mapLiVisible) {
						$('#ShowMore').hide();
					}
				}, 800);
		};	
	window.COSTCO.PharmacyResultSelfService = PharmacyResultSelfService;
	$(document).ready(function() {
		if(PharmacyResultSelfService.isCMPPDormant()){
			window.location.href = "Pharmacy/member-prescription-program.html";
		}else{
			//Check if the delivery postal container in the minibar is visible
	    	let invCheckPostalCode = $.cookie('invCheckPostalCode');
	    	PharmacyResultSelfService.zipCode = invCheckPostalCode;
			PharmacyResultSelfService.getDrugDetailsByIdentifierAuthDetails();
			PharmacyResultSelfService.pop_overs();
			PharmacyResultSelfService.isFreshSearch = true;
			$("#closeMap").hide();
			/**
			 * Invoke the method getAutoSuggestedDrugAuthDetails if the user type in the text field if the character length is more than min. length configuration
			 */
			$("#cmppDrugNameTextID, #cmppAutoSuggest").keyup(function(e){
				let li = $('ul#autoSuggestionsId li');
				let liSelected = $('ul#autoSuggestionsId li.selected');
				if((e.which === 40 || e.which === 38) && (event.which === 40 || event.which === 38)){
					if(e.which === 40){
						if(liSelected){
							liSelected.removeClass('selected');
							next = liSelected.next();
							if(next.length > 0){
								liSelected = next.addClass('selected').focus();
							}else{
								liSelected = li.eq(0).addClass('selected').focus();
							}
						}else{
							liSelected = li.eq(0).addClass('selected').focus();
						}
					}else if(e.which === 38){
						if(liSelected){
							liSelected.removeClass('selected');
							next = liSelected.prev();
							if(next.length > 0){
								liSelected = next.addClass('selected').focus();
							}else{
								liSelected = li.last().addClass('selected').focus();
							}
						}else{
							liSelected = li.last().addClass('selected').focus();
						}
					}
					e.preventDefault();
					$("#cmppDrugNameTextID").val(liSelected.attr('aria-label'));
					$('label[for="cmppDrugNameTextID"]').addClass('active');
				}
				
				$('#cmppDrugNameTextID').removeClass('error');
				var drugSearchKeyword = $.trim($(this).val());
				if(drugSearchKeyword.length >= PharmacyResultSelfService.drugSearchMinLength  && e.which != 40 && e.which != 38){
					PharmacyResultSelfService.getAutoSuggestedDrugAuthDetails(drugSearchKeyword);
				}
			});
			
			$("#cmppDrugNameTextID, #cmppAutoSuggest").keydown(function(e){
				if((e.which === 40 || e.which === 38)){
					e.preventDefault();
				}
			});
			
			/**
			 * Form handling and submission handling once the user click on the Compare Price button in the form
			 */
			$('#cmppSubmitId').on('click',function(){
				let validationSuccess = PharmacyResultSelfService.validateDrugForm();
				if(validationSuccess){
					$("#cmppSubmitFormId").submit();
				}else{
					$('#div_drugNameAutoSuggestionsError').show();
					$('#cmppDrugNameTextID').addClass('error');
					$('#div_drugNameAutoSuggestionsError').addClass('error');
					let displayError = '';
					displayError += COSTCO.util.tmpl('templ_drug_names_suggestions_error_display', {});
					$('#div_drugNameAutoSuggestionsError').html(displayError);
					$('.cmppAutoSuggest').hide();
				}
			});
			/**
			 * Form handling and submission handling once the user press the Enter button in the text field blur
			 */
			$('#cmppDrugNameTextID').keypress(function (event){
				if (event.which == PharmacyResultSelfService.EnterKeywordCode) {
					let validationSuccess = PharmacyResultSelfService.validateDrugForm();
					if(validationSuccess){
						$("#cmppSubmitFormId").submit();
					}else{
						$('#div_drugNameAutoSuggestionsError').show();
						$('#cmppDrugNameTextID').addClass('error');
						$('#div_drugNameAutoSuggestionsError').addClass('error');
						let displayError = '';
						displayError += COSTCO.util.tmpl('templ_drug_names_suggestions_error_display', {});
						$('#div_drugNameAutoSuggestionsError').html(displayError);
						$('.cmppAutoSuggest').hide();
						event.preventDefault();
				        return false;
					}
				}
			});
			/**
			 * 
			 */
			$('#cmppDrugNameTextID').focusin(function() {
				let drugSearchKeyword = $.trim($(this).val());
				if(drugSearchKeyword.length >= PharmacyResultSelfService.drugSearchMaxLength){
					PharmacyResultSelfService.getAutoSuggestedDrugAuthDetails(drugSearchKeyword);
				}
			});

			$(document).mouseup(function (e) { 
				var container = $("#compare-price-container"); 
				if(!container.is(e.target) &&  
				container.has(e.target).length === 0) { 
					window.setTimeout(function() {
						$('.cmppAutoSuggest').hide();
						$('#cmppDrugNameTextID').removeClass('error');
						$('#div_drugNameAutoSuggestionsError').removeClass('error');
						$('#div_drugNameAutoSuggestionsError').hide();
					}, 300);
				} 
			}); 
			/**
			 * 
			 */
			$('#cmppDrugNameTextID').on('input', function() {
				let drugSearchKeyword = $.trim($(this).val());
				if(drugSearchKeyword.length < PharmacyResultSelfService.drugSearchMaxLength) {
					$('#cmppAutoSuggest').hide();
					let displayError = '';
					$('#cmppDrugNameTextID').removeClass('error');
					$('#div_drugNameAutoSuggestionsError').html(displayError);
				}
			});
			$('#costcoModalView').on('click', function() {
				showMoreMap();
			});
			$('#ShowMore').on('click', function() {
					$('ul#costcoModalBodyData li:hidden').slice(0, 2).show();
					if ($('ul#costcoModalBodyData li').length == $('ul#costcoModalBodyData li:visible').length) {
						$('#ShowMore').hide();
					};
			});
			$('select#filter_brand option').on('change', function() {
				var text = $(this).text().replace(/ /g,'');
				if ($('select').width() < 1198 && text.length() === 26) {
				  text = text.substring(0, 26) + '...';
				  $(this).text(text);
				}
			  });
		}
		
		if ($('.link-membership-pet-meds').length > 0) {
			COSTCO.LinkMembership.init();
		}
	});
});



// WEBPACK FOOTER //
// ./js/cmpp/pharmacyresultsselfservice.js